import { BaseApi } from "../BaseApi";
import { InterceptToken } from "../../interceptors/TokenInterceptor";
import { createVoucherDownloader } from "../../utils/VoucherDownloadUtils";

const crearAutorizacionUrl = "api/v1/websalud/primeraars/sesion/cierre";
const registrarInfoAutorizacionUrl =
  "api/v1/websalud/primeraars/autorizaciones/informacion";
const registrarInfoAutorizacionPrimeraUrl =
  "api/v1/websalud/primeraars/autorizaciones/informacion/primera";
const subirArchivoAutorizacionUrl =
  "api/v1/websalud/primeraars/autorizaciones/soporte";
const getAutorizacionesUrl = "api/v1/websalud/primeraars/autorizaciones";
const getInfoAutorizacionUrl =
  "api/v1/websalud/primeraars/autorizaciones/informacion";

const modificarDiagnosticoDefinitivoUrl =
  "api/v1/websalud/primeraars/autorizaciones/diagnosticodefinitivo/modificar";

const reactivarAutorizacionUrl = "api/v1/websalud/primeraars/sesion/reinicio";

const descargarReporteVoucherUrl =
  "api/v1/websalud/primeraars/autorizaciones/voucher";
  
const getCirugiasLiberadasUrl =
  "api/v1/websalud/primeraars/autorizaciones/cirujias-liberadas";

const getDetalleAutorizacionUrl = (request) =>
  `api/v1/websalud/primeraars/autorizaciones/${request.numeroAutorizacion}`;

const cancelarAutorizacionUrl = (request) =>
  `api/v1/websalud/primeraars/autorizaciones/${request.numeroAutorizacion}/cancelacion`;

const getDetalleAutorizacioMadrenUrl = (request) =>
  `api/v1/websalud/primeraars/autorizaciones/madre/${request.numeroAutorizacionMadre}`;

const crearAutorizacion = (request) =>
  InterceptToken(
    BaseApi.post,
    crearAutorizacionUrl,
    request.requestData,
    request.requestHeaders
  ).then((response) => response.data);

const cancelarAutorizacion = (request) =>
  InterceptToken(
    BaseApi.post,
    cancelarAutorizacionUrl(request.requestData),
    {
      numeroPlastico: request?.requestData?.numeroPlastico,
      codigoMotivo: request?.requestData?.codigoMotivo,
    },
    request.requestHeaders
  ).then((response) => response.data);

const reactivarAutorizacion = (request) =>
  InterceptToken(BaseApi.post, reactivarAutorizacionUrl, request).then(
    (response) => response.data
  );

const registrarInfoAutorizacion = (request) =>
  InterceptToken(BaseApi.post, registrarInfoAutorizacionUrl, request).then(
    (response) => response.data
  );

const registrarInfoAutorizacionPrimera = (request) =>
  InterceptToken(
    BaseApi.post,
    registrarInfoAutorizacionPrimeraUrl,
    request
  ).then((response) => response.data);

const getInfoAutorizacion = (request) =>
  InterceptToken(BaseApi.get, getInfoAutorizacionUrl, request).then(
    (response) => response.data
  );

const subirArchivoAutorizacion = (request) =>
  InterceptToken(BaseApi.post, subirArchivoAutorizacionUrl, request).then(
    (response) => response.data
  );

const getAutorizaciones = (request) =>
  InterceptToken(BaseApi.get, getAutorizacionesUrl, request).then(
    (response) => response.data
  );

const getDetalleAutorizacion = (request) =>
  InterceptToken(BaseApi.get, getDetalleAutorizacionUrl(request), request).then(
    (response) => response.data
  );

const modificarDiagnosticoDefinitivo = (request) =>
  InterceptToken(BaseApi.post, modificarDiagnosticoDefinitivoUrl, request).then(
    (response) => response.data
  );

const getDetalleAutorizacionMadre = (request) =>
  InterceptToken(
    BaseApi.get,
    getDetalleAutorizacioMadrenUrl(request),
    null
  ).then((response) => response.data);

  const descargarReporteVoucher = createVoucherDownloader(descargarReporteVoucherUrl);

const getCirugiasLiberadas = (request) =>
  InterceptToken(BaseApi.get, getCirugiasLiberadasUrl, request).then(
    (response) => response.data
  );
const exportedObject = {
  crearAutorizacion,
  cancelarAutorizacion,
  reactivarAutorizacion,
  registrarInfoAutorizacion,
  registrarInfoAutorizacionPrimera,
  subirArchivoAutorizacion,
  getAutorizaciones,
  getDetalleAutorizacion,
  getInfoAutorizacion,
  modificarDiagnosticoDefinitivo,
  getDetalleAutorizacionMadre,
  descargarReporteVoucher,
  getCirugiasLiberadas,
};

export default exportedObject;
